import { createSharedComposable } from '@vueuse/core';
import type { Channels } from '../../..';
import { ref } from 'vue';

export const useChannels = createSharedComposable(() => {
    const channels = ref<Channels>()

    /**
     * 更新 channels
     */
    function updateChannels(data: Channels) {
        channels.value = data;
    }

    return {
        channels,
        updateChannels,
    }
})
